import { render, staticRenderFns } from "./editReserveServiceList.vue?vue&type=template&id=1b0137fd&scoped=true"
import script from "./editReserveServiceList.vue?vue&type=script&lang=js"
export * from "./editReserveServiceList.vue?vue&type=script&lang=js"
import style0 from "./editReserveServiceList.vue?vue&type=style&index=0&id=1b0137fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0137fd",
  null
  
)

export default component.exports